/* Filtrous Website V3 — McMaster paradigm storefront engine (index-driven).
   Flow: BOOM home (navy face band + dense photo grid) -> explode -> the sheet
   (parametric filters + quick add) -> PDP. ONE search box that only routes into
   the taxonomy (never a results page).
   Search MATCHING = Boost API for typo tolerance + FAMILY_SYNONYMS routing layer
   on top (Boost knows no lab vocab: "hplc vials"/"falcon" = 0 Boost hits, probed
   2026-07-09). Our router maps Boost/synonym hits -> taxonomy nodes and picks the
   destination. Search COMPOSES with an active sheet: when a sheet is narrowed, a
   query matches WITHIN the filtered rows first, with a one-click "search
   everything instead" escape to the global router. Filters stay client-side over
   the catalog index. Config via window.FV3_CONFIG. Works on Shopify (real cart)
   and a local harness (mock). */
(function () {
  "use strict";
  var CFG = Object.assign({
    indexUrl: "/catalog-index.json",
    cartAddUrl: "/cart/add.js",
    cartGetUrl: "/cart.js",
    productBase: "/products/",     // real Shopify product URL base (+ handle)
    // Boost search engine under our skin (matching only; our router owns routing).
    boostUrl: "https://services.mybcapps.com/bc-sf-filter/search?shop=filtrous-sandbox-acumatica.myshopify.com",
    inApp: true,                   // true = View routes to in-app hash PDP; false = real product URL
    logoUrl: "filtrous-logo-canonical.png", // relative = harness; theme passes asset_url
    aboutUrl: "/pages/about-us",   // art banner + footer About link
    logoWhiteUrl: "filtrous-logo-white.png", // white wordmark for the navy footer
    artBannerUrl: "",              // VA nudibranch banner (set on theme when delivered)
    mock: false                    // local harness -> fake cart
  }, window.FV3_CONFIG || {});

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var el = function (t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]; }); };
  var money = function (v) { var n = parseFloat(v); return isNaN(n) ? "" : "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  // Call for Quote — any product whose SKU contains "OSK" shows "Call for Quote" instead of a price.
  var isOskQuote = function (p) { if (!p || !p.sku) return false; var s = String(p.sku).toUpperCase(); return s.indexOf("OSK") >= 0 || s === "EXK-BD-0096-PP"; };
  var QUOTE_HTML = '<span class="fv3-quote" style="color:var(--navy,#082F4B);font-weight:400">Call for Quote</span>';
  var priceOrQuote = function (p) { return isOskQuote(p) ? QUOTE_HTML : money(p.price); };
  // ---- Customer-facing "Sold Out" override (DISPLAY ONLY; backend/catalog untouched) ----
  // These SKUs are out of stock per Acumatica, but the static catalog-index snapshot
  // still lists them available. Force their V3 cards to render Sold Out (disabled add).
  // OSK / Call-for-Quote SKUs are intentionally excluded. Remove SKUs here once the
  // catalog index refreshes from Acumatica. Snapshot: Filtrous_InStock_but_Empty_2026-07-28.
  var FORCE_OOS = {"471130180":1,"596121302":1,"596123302":1,"624850202":1,"632030202":1,"652040202":1,"682030202":1,"ABP-NAB-GFPA050":1,"ABP-NAB-GFPX050":1,"ABP-NAB-MNGA050":1,"ABP-NAB-MNGX050":1,"ABP-NAB-MTFPA050":1,"ABP-NAB-MTFPX050":1,"ABP-NAB-RFPA050":1,"ABP-NAB-RFPX050":1,"ALC-13-1102":1,"ALS-09-1412":1,"ANK-11-1022":1,"ASP-10-0005":1,"BTG-20-0400":1,"CHM-A1C-0250":1,"CHM-ALB-0600":1,"CHM-ALP-0500":1,"CHM-ALT-0500":1,"CHM-AST-0500":1,"CHM-BUN-0500":1,"CHM-CAL-0600":1,"CHM-CDC-3000":1,"CHM-CDQ-3000":1,"CHM-CHO-0500":1,"CHM-CO2-0800":1,"CHM-CRE-0500":1,"CHM-CRK-0500":1,"CHM-GLU-0500":1,"CHM-HCR-0270":1,"CHM-HDC-1000":1,"CHM-HDL-0500":1,"CHM-IRN-1000":1,"CHM-LDC-1000":1,"CHM-LDL-0500":1,"CHM-LP1-3000":1,"CHM-LP2-3000":1,"CHM-MAG-0800":1,"CHM-MCL-3000":1,"CHM-MQ1-5000":1,"CHM-MQ2-5000":1,"CHM-PHO-0800":1,"CHM-TBL-0500":1,"CHM-TPR-0800":1,"CHM-TRG-0500":1,"CHM-URA-0500":1,"COV-12-0000-K":1,"COV-AT-0025":1,"ETA-05-0100":1,"EXK-BD-0096":1,"EXK-CL-0100":1,"EXK-CO-0050":1,"EXK-LY-0100":1,"EXK-MJ-0096":1,"FDE-20-0100":1,"FDE-20-0400":1,"FPH-38-0120":1,"FPH-96-1005":1,"FPH-96-2005":1,"LC230-4":1,"LC365-4":1,"LLF-00-0005":1,"LLF-02-0010":1,"LLS-10-0001":1,"LSR-410-125-1":1,"LSR-410-125-10":1,"LSS-301-10-12":1,"LSS-301-200-1":1,"LSS-301-200-12":1,"LSS-401-1":1,"LSS-401-10":1,"LSS-501-1":1,"LSS-501-10":1,"MBP-03-6030":1,"MBP-09-1404":1,"MBP-21-4425":1,"MBP-99-1401":1,"MBP-99-2401":1,"MCF-10-0015":1,"MDA-CO-0025":1,"MDA-EF-0025":1,"MDB-CO-0025":1,"MES-01-0100":1,"MES-20-0100":1,"MES-20-0400":1,"MNA-CO-0050":1,"MNA-EN-0050":1,"MNB-CO-0050":1,"MNB-EN-0050":1,"MOP-05-0100":1,"MOP-20-0100":1,"MOP-20-0400":1,"MXA-CO-0025":1,"NGV-LG-3100-C":1,"NGV-LG-4100-C":1,"NGV-MM-3100-C":1,"NGV-MM-4100-C":1,"NGV-SM-4100-C":1,"NGV-XL-3100-C":1,"PBS-10-0400":1,"PBT-10-0400":1,"PCR-MM-0001":1,"PREPL-DUD20124N!":1,"PREPL-DUD7124N!":1,"PTR-AN-0010":1,"PTR-AN-0200":1,"PTR-AN-0300":1,"PTR-AN-1250":1,"QBE-N3-0500":1,"QBE-PB-0500":1,"QBE-PX-0500":1,"QBE-PY-0500":1,"QBE-PZ-0500":1,"QBE-QB-1000":1,"QBE-QC-1000":1,"QBE-QF-1000":1,"QBE-QN-0500":1,"RGS-00-0100":1,"SDS-20-0100":1,"SFN-AQ-2030":1,"SFN-AW-2030":1,"SFN-BR-2025":1,"SFN-BW-2017":1,"SFN-CR-1013":1,"SGS-00-0100":1,"SPG-00-0150":1,"SSB-20-0100":1,"SSB-20-0300":1,"SSC-20-0100":1,"SSC-20-0400":1,"SSP-20-0100":1,"SSP-20-0400":1,"TAE-50-0100":1,"TAE-50-0400":1,"TAS-20-0100":1,"TAS-20-0400":1,"TBE-10-0100":1,"TBE-10-0400":1,"TBS-20-0100":1,"TBS-20-0400":1,"TBT-20-0100":1,"TBT-20-0400":1,"TC-10-RNBW":1,"TC-75-RNBW":1,"TEB-20-0050":1,"TGN-06-0005":1,"TGN-10-0100":1,"TGN-10-0400":1,"TGS-06-0005":1,"TGS-10-0100":1,"TGS-10-0400":1,"TGT-25-0100":1,"TGT-25-0400":1,"THS-10-0100":1,"THS-10-0400":1,"TRS-01-0100":1,"TSR-10-0100":1,"TSR-10-0400":1,"TTG-00-0010":1,"UCK-00-1050":1,"VAL-24-0200-K2":1,"VAL-24-0200-K3":1,"VAV-15-0080-K1":1,"VLL-24-0200-K3":1,"WAT-01-2160":1,"XSP-AE-0010":1,"XSP-AE-0100":1,"XSP-AE-0200":1,"XSP-AE-1000":1};
  var forcedOOS = function (p) { return !!(p && p.sku && FORCE_OOS[String(p.sku).toUpperCase()] && !isOskQuote(p)); };
  var inStock = function (p) { return !!(p && p.available !== false && !forcedOOS(p)); };

  var IDX = null, MOUNT = null, cartCount = 0;
  var maps = { bySku: {}, byFamily: {}, byHandle: {}, nodes: [] }; // nodes = searchable taxonomy list

  /* ---------------- local routing match (exact/prefix/synonym only) ----------------
     Typo tolerance is Boost's job now (the hand-rolled Damerau-Levenshtein matcher
     is retired). scoreNode does deterministic word/prefix/synonym routing over the
     taxonomy - the "routing layer on top" of Boost, and the sole matcher for lab
     vocab Boost doesn't know ("hplc vials", "falcon"). */
  function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim(); }
  // score a query against a node name/synonyms: lower is better; null if no match
  // Lab-vocabulary synonyms: how buyers actually search vs what the catalog calls it.
  // "hplc vials" -> autosampler vials (the catalog never writes "HPLC" on them).
  var FAMILY_SYNONYMS = {
    "autosampler-vials-caps-v2": ["hplc", "lc", "chromatography", "autosampler", "crimp", "screw top", "2ml", "9mm", "11mm"],
    "autosampler-kits-v2": ["hplc", "autosampler", "vial kit", "convenience kit"],
    "vial-inserts-v2": ["insert", "hplc", "autosampler", "low volume", "micro insert"],
    "epa-voa-vials-v2": ["voa", "epa", "environmental", "40ml", "water testing"],
    "headspace-vials-v2": ["headspace", "gc", "gas chromatography", "20ml"],
    "scintillation-vials-v2": ["scintillation", "lsc", "20ml", "storage vial"],
    "capillaries-v2": ["capillary", "tubing", "peek", "lc", "fitting"],
    "syringe-filters-v2": ["syringe filter", "ptfe", "nylon", "pes", "pvdf", "membrane", "0.22", "0.45"],
    "membrane-filters-v2": ["membrane", "disc filter", "mce"],
    "vacuum-filters-v2": ["vacuum", "bottle top", "filtration", "filter unit"],
    "filter-vials-v2": ["filter vial", "mini uniprep", "whatman"],
    "filter-paper-v2": ["filter paper", "qualitative", "cellulose", "grade"],
    "filter-plates-v2": ["filter plate", "96 well filter"],
    "quechers-v2": ["quechers", "dspe", "pesticide", "cleanup"],
    "sample-preparation-v2": ["spe", "solid phase extraction", "cartridge", "cleanup", "sorbent"],
    "extraction-kits-v2": ["dna extraction", "rna extraction", "nucleic acid", "spin column"],
    "plasmid-prep-v2": ["miniprep", "maxiprep", "plasmid", "dna prep"],
    "extraction-buffers-v2": ["lysis buffer", "wash buffer", "elution", "binding buffer"],
    "universal-tips-v2": ["pipette tip", "filter tip", "200ul", "1000ul", "10ul", "barrier tip"],
    "lts-pipette-tips-v2": ["rainin", "lts", "low retention"],
    "robotic-tips-v2": ["tecan", "hamilton", "robotic", "automation", "conductive"],
    "dispenser-tips-v2": ["repeater", "dispenser tip", "combitip"],
    "serological-pipettes-v2": ["serological", "stripette", "5ml", "10ml", "25ml"],
    "graduated-pipettes-v2": ["graduated", "mohr", "measuring pipette"],
    "glass-pipettes-v2": ["glass pipette", "pasteur"],
    "syringes-v2": ["luer", "syringe", "lock", "slip tip"],
    "culture-flasks-v2": ["t25", "t75", "t175", "tissue culture", "cell culture flask", "vented"],
    "culture-dishes-v2": ["petri", "cell culture dish", "tissue culture dish"],
    "cell-strainers-filters-v2": ["cell strainer", "40um", "70um", "100um"],
    "inoculating-loops-v2": ["inoculating loop", "microbiology"],
    "pcr-plates-v2": ["pcr", "qpcr", "96 well", "384 well", "plate"],
    "strip-tubes-v2": ["pcr strip", "8 strip", "tube strip", "0.2ml"],
    "sealing-membranes-v2": ["pcr seal", "adhesive film", "foil seal"],
    "cold-blocks-v2": ["cold block", "cooler", "pcr rack"],
    "pcr-kits-v2": ["pcr kit", "qpcr", "detection kit", "master mix", "covid"],
    "master-mix-v2": ["master mix", "pcr mix", "qpcr mix", "taq"],
    "biology-buffers-v2": ["tris", "tae", "tbe", "pbs", "sds", "edta", "running buffer", "molecular"],
    "ph-buffers-v2": ["ph buffer", "calibration", "ph 4", "ph 7", "ph 10"],
    "solvents-v2": ["hplc", "acetonitrile", "methanol", "solvent", "mobile phase", "acn", "meoh"],
    "water-v2": ["hplc water", "di water", "deionized", "molecular grade"],
    "centrifuge-tubes-v2": ["falcon", "conical", "15ml", "50ml", "centrifuge"],
    "96-deep-well-plates-v2": ["deep well", "96 well", "microplate", "storage plate"],
    "vtm-v2": ["viral transport", "vtm", "utm", "swab media"],
    "sampling-bags-v2": ["sample bag", "whirl pak", "stomacher"],
    "biological-specimen-collection-v2": ["blood collection", "urine", "edta tube", "serum", "vacutainer", "specimen", "swab"],
    "glassware-plastics-v2": ["beaker", "bottle", "cylinder", "flask", "glassware"],
    "weighing-v2": ["weigh boat", "spatula", "weighing dish"],
    "tape-v2": ["labeling tape", "autoclave tape", "label"],
    "gloves-v2": ["nitrile", "latex", "exam glove", "powder free"],
    "masks-v2": ["face mask", "surgical", "respirator"],
    "biohazard-bags-v2": ["biohazard", "autoclave bag"]
  };
  // coverage-based: reward matching MORE of the query; prefer actionable leaf
  // sheets over roll-up categories; fuzzy-tolerant on words >=4 chars.
  function scoreNode(q, node) {
    var nq = norm(q); if (!nq) return null;
    var hay = node.hay || norm(node.n);
    var name = norm(node.n);
    var qt = nq.split(" ").filter(Boolean);
    var hw = hay.split(" ");
    var cw = (node.hayCore || hay).split(" ");
    // word-level: exact word or word-prefix (NOT raw substring, so "nitrile"
    // does not match "acetonitrile"). No edit-distance - Boost owns typos.
    var wordHit = function (words, tok) {
      for (var j = 0; j < words.length; j++) {
        if (words[j] === tok || (tok.length >= 3 && words[j].indexOf(tok) === 0)) return true;
      }
      return false;
    };
    var covered = 0;
    for (var i = 0; i < qt.length; i++) {
      // Name/synonym hits count FULL; dept/category-path hits count HALF - a
      // sibling family must not tie the real target just because its parent
      // category name contains a query word ("hplc vials": Autosampler Kits was
      // tying Autosampler Vials & Caps via the "Autosampler Vials, Caps & Kits"
      // category name; QA R1 finding 9).
      if (wordHit(cw, qt[i])) covered += 1;
      else if (wordHit(hw, qt[i])) covered += 0.5;
    }
    if (covered <= 0) return null;
    var s = -(covered / qt.length) * 40 - covered * 6;   // fraction + absolute coverage
    // whole-query phrase as a word boundary (not inside a longer word)
    if (new RegExp("(^| )" + nq.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "( |$)").test(hay)) s -= 22;
    if (name === nq) s -= 60;                             // exact family name
    else if (name.indexOf(nq) === 0) s -= 20;             // name prefix
    if (node.t === "leaf") s -= 4;                        // sheets are actionable
    else if (node.t === "cat") s += 5;                    // roll-up = extra click
    else if (node.t === "dept") s += 8;
    else if (node.t === "spec") s -= 1;
    return s;
  }

  /* ---------------- bootstrap ---------------- */
  function build() {
    IDX.products.forEach(function (p) { maps.bySku[p.sku.toUpperCase()] = p; if (p.handle) maps.byHandle[p.handle] = p; });
    Object.keys(IDX.families).forEach(function (h) {
      maps.byFamily[h] = IDX.products.filter(function (p) { return p.families.indexOf(h) >= 0; });
    });
    // searchable taxonomy nodes: leaves (+ categories + depts) with synonyms
    IDX.departments.forEach(function (d) {
      maps.nodes.push({ t: "dept", n: d.name, slug: d.slug, route: "#/d/" + d.slug, path: "", hay: norm(d.name), hayCore: norm(d.name) });
      d.categories.forEach(function (c) {
        maps.nodes.push({ t: "cat", n: c.name, dept: d.slug, route: "#/d/" + d.slug + "/" + encodeURIComponent(c.name), path: d.name, hay: norm(c.name + " " + d.name), hayCore: norm(c.name) });
        c.leaves.forEach(function (lf) {
          var fam = IDX.families[lf.handle] || {};
          var syn = synFor(lf.display, fam).concat(FAMILY_SYNONYMS[lf.handle] || []);
          maps.nodes.push({
            t: "leaf", n: lf.display, handle: lf.handle, count: lf.count,
            route: "#/f/" + lf.handle, path: d.name + " / " + c.name,
            syn: syn, hay: norm([lf.display, d.name, c.name].concat(syn).join(" ")),
            hayCore: norm([lf.display].concat(syn).join(" ")) // name + synonyms only, no path
          });
        });
      });
    });
    // spec-value nodes: search "double" -> "Double Layer" (Syringe Filters), routes to a PRE-FILTERED sheet.
    // Enum facet values only (clean, filterable); deduped per family+key+value.
    Object.keys(IDX.families).forEach(function (h) {
      var fam = IDX.families[h];
      var prods = maps.byFamily[h] || [];
      (fam.columns || []).forEach(function (c) {
        if (c.type !== "enum") return;
        var vals = {};
        prods.forEach(function (p) { var v = p.specs[c.key]; if (v != null && v !== true) vals[v] = (vals[v] || 0) + 1; });
        Object.keys(vals).forEach(function (v) {
          if (vals[v] < 1) return;
          maps.nodes.push({
            t: "spec", n: String(v), handle: h, key: c.key, val: v, count: vals[v],
            route: "#/f/" + h + "?k=" + encodeURIComponent(c.key) + "&v=" + encodeURIComponent(v),
            path: fam.display + " · " + c.label,
            hay: norm(String(v) + " " + fam.display), hayCore: norm(String(v))
          });
        });
      });
    });
  }
  function synFor(name, fam) {
    var s = [];
    var base = name.toLowerCase();
    if (/vials?/.test(base)) s.push("vial");
    if (/tips?/.test(base)) s.push("tip", "pipette tip");
    if (/filters?/.test(base)) s.push("filter");
    if (/buffers?/.test(base)) s.push("buffer");
    if (/tubes?/.test(base)) s.push("tube");
    if (/pipettes?/.test(base)) s.push("pipette");
    if (/plates?/.test(base)) s.push("plate", "well plate");
    if (/gloves?/.test(base)) s.push("glove", "nitrile");
    // singular/plural
    s.push(base.replace(/s$/, ""));
    return s;
  }

  /* ---------------- cart ----------------
     Shopify: /cart/add.js merges quantities natively; the cart icon goes to the
     stock /cart page (spec: cart/checkout = stock Shopify, unchanged).
     Harness (mock): a real line-item map + drawer so QA can see lines, merge
     quantities, and remove items (QA R1 finding 6). */
  var CART = {}; // mock lines: sku -> qty (insertion order preserved)
  function cartSum() { var n = 0; for (var k in CART) n += CART[k]; return n; }
  function refreshCart() {
    if (CFG.mock) { setCart(cartSum()); return; }
    fetch(CFG.cartGetUrl, { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCart(c.item_count || 0); })
      .catch(function () {});
  }
  function setCart(n) { cartCount = n; var e = $(".fv3-cart .count"); if (e) e.textContent = n; }
  function addToCart(product, qty, btn) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var done = function () {
      if (btn) { var orig = btn.getAttribute("data-label") || btn.textContent; btn.setAttribute("data-label", orig); btn.classList.add("done"); btn.textContent = "Added"; setTimeout(function () { btn.classList.remove("done"); btn.textContent = orig; }, 1400); }
      toast(qty + " x " + product.sku + " added to cart");
    };
    if (CFG.mock || !product.vid) {
      CART[product.sku] = (CART[product.sku] || 0) + qty; // same item merges, never a duplicate line
      setCart(cartSum());
      if ($(".fv3-drawer")) paintCartDrawer(); // live-update if the drawer is open
      done(); return;
    }
    fetch(CFG.cartAddUrl, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: product.vid, quantity: qty }] })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { setCart(cartCount + qty); done(); })
      .catch(function () { toast("Could not add " + product.sku + ". Please retry."); });
  }
  // mock cart drawer (harness only)
  function openCart() {
    if (!CFG.mock) { window.location.href = "/cart"; return; }
    if ($(".fv3-cartveil")) { closeCart(); return; }
    var veil = el("div", "fv3-cartveil");
    veil.addEventListener("click", function (e) { if (e.target === veil) closeCart(); });
    var drawer = el("aside", "fv3-drawer");
    drawer.setAttribute("aria-label", "Cart");
    veil.appendChild(drawer);
    document.body.appendChild(veil);
    paintCartDrawer();
  }
  function closeCart() { var v = $(".fv3-cartveil"); if (v) v.remove(); }
  function paintCartDrawer() {
    var drawer = $(".fv3-drawer"); if (!drawer) return;
    var skus = Object.keys(CART);
    var h = '<div class="dhead"><h3>Cart</h3><button class="dclose" aria-label="Close cart">&times;</button></div>';
    if (!skus.length) {
      h += '<div class="dempty">Your cart is empty. Add parts from any spec sheet.</div>';
    } else {
      var subtotal = 0;
      h += '<div class="dlines">';
      skus.forEach(function (sku) {
        var p = maps.bySku[sku.toUpperCase()] || { sku: sku, title: sku, price: 0 };
        var qty = CART[sku], line = parseFloat(p.price) * qty || 0; subtotal += line;
        h += '<div class="dline" data-sku="' + esc(sku) + '">' +
          '<div class="dl-info"><span class="dl-sku">' + esc(p.sku) + '</span><span class="dl-t">' + esc(String(p.title).split(",")[0]) + '</span></div>' +
          '<div class="dl-ctl"><button class="dqty" data-d="-1" aria-label="Decrease quantity">&minus;</button><b>' + qty + '</b><button class="dqty" data-d="1" aria-label="Increase quantity">+</button>' +
          '<span class="dl-p">' + money(line) + '</span><button class="drm">Remove</button></div></div>';
      });
      h += '</div><div class="dfoot"><span>Subtotal</span><b>' + money(subtotal) + '</b></div>' +
        '<p class="dnote">This is the local harness cart. Checkout runs on the Shopify store.</p>';
    }
    drawer.innerHTML = h;
    $(".dclose", drawer).addEventListener("click", closeCart);
    Array.prototype.forEach.call(drawer.querySelectorAll(".dline"), function (row) {
      var sku = row.getAttribute("data-sku");
      Array.prototype.forEach.call(row.querySelectorAll(".dqty"), function (b) {
        b.addEventListener("click", function () {
          CART[sku] = Math.max(1, CART[sku] + parseInt(b.getAttribute("data-d"), 10));
          setCart(cartSum()); paintCartDrawer();
        });
      });
      row.querySelector(".drm").addEventListener("click", function () {
        delete CART[sku]; setCart(cartSum()); paintCartDrawer();
      });
    });
  }
  var toastT;
  function toast(msg) {
    var t = $(".fv3-toast"); if (!t) { t = el("div", "fv3-toast"); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  /* ---------------- chrome (white header, existing-site style) ----------------
     All persistent, built once, never re-rendered so search wiring survives every
     navigation. Structure (David 7/17: match the live site's white header — real
     logo, cart + sign-in adjacent, no quick links, no navy band):
       .fv3-top
         .fv3-util     thin white trust line + links  - scrolls away
         .fv3-headrow  logo + the ONE search input + sign-in/cart - STICKY, white */
  function chrome() {
    var top = el("header", "fv3-top");
    // David 7/18: order is (1) sticky logo/search/sign-in+cart row, (2) the thin
    // track-order/bulk-quote strip BELOW it, (3) the nudibranch art banner slot
    // (VA art lands this weekend; clicking it routes to the About page).
    top.innerHTML =
      '<div class="fv3-headrow"><div class="fv3-headrow-in">' +
        '<a class="fv3-logo" href="#/"><img src="' + esc(CFG.logoUrl) + '" alt="Filtrous" /></a>' +
        '<div class="fv3-search">' +
          '<span class="mag">' + svgSearch() + '</span>' +
          '<input type="search" placeholder="Search a part number, membrane, porosity..." autocomplete="off" aria-label="Search parts and categories" />' +
          '<div class="fv3-suggest" role="listbox"></div>' +
        '</div>' +
        '<div class="fv3-actions">' +
          '<a class="signin" data-u="signin">' + svgUser() + '<span>Sign in</span></a>' +
          '<button class="fv3-cart" aria-label="Cart">' + svgCart() + '<span class="count">0</span></button>' +
        '</div>' +
      '</div></div>' +
      '<div class="fv3-util"><div class="fv3-util-in">' +
        '<span class="trust">Same-day shipping&nbsp;&middot;&nbsp;<a href="#/quality">COA on every lot</a>&nbsp;&middot;&nbsp;Net-30 for labs</span>' +
        '<span class="ulinks"><a data-u="track">Track order</a><a href="mailto:support@filtrous.com?subject=Bulk%20quote%20request">Bulk / quote</a></span>' +
      '</div></div>' +
      // art banner: hidden until CFG.artBannerUrl is set (VA delivers this weekend);
      // whole banner links to the About page (David 7/18 item 8)
      (CFG.artBannerUrl
        ? '<a class="fv3-artbanner" href="' + esc(CFG.aboutUrl) + '"><img src="' + esc(CFG.artBannerUrl) + '" alt="Filtrous" /></a>'
        : '');
    wireSearch(top);
    // account links: real Shopify routes on the store; honest "not here" on the
    // harness (no backend to sign in to) - never a silent dead click (QA R1 prose)
    var track = $('[data-u="track"]', top), signin = $('[data-u="signin"]', top);
    if (CFG.mock) {
      var noAcct = function (e) { e.preventDefault(); toast("Accounts are not available in the local harness"); };
      track.addEventListener("click", noAcct); signin.addEventListener("click", noAcct);
    } else {
      track.href = "/account"; signin.href = "/account/login";
    }
    return top;
  }
  /* ---------------- footer (David 7/18 item 7 - keep the footer, drop products) ----------------
     Lean Filtrous footer: brand + Company / Ordering / Policies link columns.
     No product links. Built once, persistent (theme's own footer is hidden). */
  function footer() {
    var f = el("footer", "fv3-footer");
    var year = (new Date()).getFullYear();
    f.innerHTML =
      '<div class="fv3-footer-in">' +
        '<div class="ff-brand">' +
          '<a href="#/" class="ff-logo"><img src="' + esc(CFG.logoWhiteUrl || CFG.logoUrl) + '" alt="Filtrous" /></a>' +
          '<p>Lab consumables, shipped today.</p>' +
          '<p>COA on every lot &middot; Net-30 for labs.</p>' +
        '</div>' +
        '<nav class="ff-col"><h4>Filtrous</h4>' +
          '<a href="' + esc(CFG.aboutUrl) + '">About us</a>' +
          '<a href="#/quality">Quality &amp; COA</a>' +
          '<a href="mailto:support@filtrous.com">Contact</a>' +
        '</nav>' +
        '<nav class="ff-col"><h4>Ordering</h4>' +
          '<a data-u="track2">Track order</a>' +
          '<a href="#/quality">Net-30 terms</a>' +
        '</nav>' +
        '<nav class="ff-col"><h4>Policies</h4>' +
          '<a href="/policies/shipping-policy">Shipping</a>' +
          '<a href="/policies/refund-policy">Returns</a>' +
          '<a href="/policies/privacy-policy">Privacy</a>' +
          '<a href="/policies/terms-of-service">Terms</a>' +
        '</nav>' +
      '</div>' +
      '<div class="fv3-footer-legal">&copy; ' + esc(year) + ' Filtrous. All rights reserved.</div>';
    var t2 = $('[data-u="track2"]', f);
    if (CFG.mock) { t2.addEventListener("click", function (e) { e.preventDefault(); toast("Accounts are not available in the local harness"); }); }
    else { t2.href = "/account"; }
    return f;
  }

  function svgSearch() { return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="7" cy="7" r="4.5"/><path d="M11 11l3 3"/></svg>'; }
  function svgCart() { return '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 2h2l1.5 9h8L16 5H5"/><circle cx="7" cy="15" r="1.1" fill="currentColor" stroke="none"/><circle cx="13" cy="15" r="1.1" fill="currentColor" stroke="none"/></svg>'; }
  function svgUser() { return '<svg width="17" height="17" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="6" r="3.2"/><path d="M3 15.5c.8-3 3.1-4.3 6-4.3s5.2 1.3 6 4.3"/></svg>'; }

  /* ---------------- search: Boost matching + taxonomy routing + compose ----------------
     Local scoring (scoreNode over synonyms) is instant and covers lab vocab Boost
     doesn't know. Boost adds typo tolerance and product recall. A monotonic token
     guards every async op so a stale response can never render or navigate over a
     newer one (spam-Enter / mid-load hardening). */
  var SRCH = { token: 0 };
  function activeSheetHandle() {
    return (/^#\/f\//.test(location.hash) && sheetState) ? sheetState.handle : null;
  }
  // Boost -> our families. Boost searches the whole sandbox; we keep only hits we
  // can place in the index (map handle -> product -> primary_family).
  function boostSearch(q, signal) {
    var url = CFG.boostUrl + "&q=" + encodeURIComponent(q) + "&limit=24";
    return fetch(url, { signal: signal, headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var famHits = {}, famOrder = [], skuHits = [];
        (d.products || []).forEach(function (bp) {
          var p = bp.handle ? maps.byHandle[bp.handle] : null;
          if (!p) return;
          var fh = p.primary_family || (p.families || [])[0];
          if (fh && IDX.families[fh]) { if (famHits[fh] == null) { famHits[fh] = 0; famOrder.push(fh); } famHits[fh]++; }
          if (skuHits.length < 4) skuHits.push(p.sku);
        });
        return { families: famOrder.map(function (h) { return { handle: h, hits: famHits[h] }; }), skus: skuHits };
      })
      .catch(function () { return { families: [], skus: [] }; }); // aborted / offline -> local only
  }
  // Ordered taxonomy nodes for a query from the LOCAL synonym/word matcher.
  function localNodes(q) {
    var scored = [];
    maps.nodes.forEach(function (nd) { var sc = scoreNode(q, nd); if (sc != null) scored.push([sc, nd]); });
    scored.sort(function (a, b) { return a[0] - b[0]; });
    return scored.map(function (x) { return x[1]; });
  }
  // Merge local family/category nodes with Boost family hits into one ordered list
  // of leaf/category nodes (Boost boosts a family already surfaced locally, and can
  // surface one local scoring missed). Returns {tax:[nodes], spec:[nodes], skus:[]}.
  function mergeRoute(q, boost) {
    var nodes = localNodes(q);
    var tax = nodes.filter(function (n) { return n.t !== "spec"; });
    var spec = nodes.filter(function (n) { return n.t === "spec"; });
    var leafByHandle = {};
    tax.forEach(function (n) { if (n.t === "leaf") leafByHandle[n.handle] = n; });
    // fold in Boost families: bump ones we have, append ones we missed
    (boost && boost.families || []).forEach(function (bf, bi) {
      if (leafByHandle[bf.handle]) {
        var idx = tax.indexOf(leafByHandle[bf.handle]);
        if (idx > 0 && bi === 0) { tax.splice(idx, 1); tax.unshift(leafByHandle[bf.handle]); } // Boost's top hit leads
      } else {
        var lf = maps.nodes.filter(function (n) { return n.t === "leaf" && n.handle === bf.handle; })[0];
        if (lf) tax.push(lf);
      }
    });
    return { tax: tax, spec: spec, skus: (boost && boost.skus) || [] };
  }
  // Apply an in-sheet text filter (compose). Returns match count. Never navigates.
  function applySheetText(q) {
    if (!sheetState) return 0;
    sheetState.text = q;
    paintRows();
    return currentRows().length;
  }
  function clearSheetText() { if (sheetState) { sheetState.text = ""; if (SRCH.reset) SRCH.reset(); paintRows(); } }
  // The "search everything instead" escape is a FULL reset: facets + compose term
  // both cleared before the global route runs. Matters when the global router
  // resolves back to the same family (same hash = no re-render), where leftover
  // narrowing silently survived (QA R1 finding 5).
  function escapeCompose(q) {
    if (SRCH.reset) SRCH.reset(); // box must not keep the released term (QA R2)
    if (sheetState) {
      sheetState.sel = {}; sheetState.range = {}; sheetState.text = "";
      rebuildFilters(); paintRows();
    }
    runGlobalSearch(q);
  }
  // Global router: SKU -> PDP; single family -> its sheet; ambiguous/none -> a
  // dedicated #/s/<q> results route (so the hash never lies about what's shown and
  // back/forward has a real entry). Boost + local merged. Guarded by SRCH.token.
  function runGlobalSearch(q) {
    q = (q || "").trim(); if (!q) return;
    var exact = maps.bySku[q.toUpperCase().replace(/\s+/g, "")];
    if (exact) { gotoPDP(exact.sku); return; }
    var my = ++SRCH.token;
    boostSearch(q).then(function (boost) {
      if (my !== SRCH.token) return; // superseded by a newer search / navigation
      var m = mergeRoute(q, boost);
      var searchHash = "#/s/" + encodeURIComponent(q);
      // a single strong SKU hit and no category -> PDP
      if (!m.tax.length && !m.spec.length && m.skus.length) { gotoPDP(m.skus[0]); return; }
      if (!m.tax.length && m.spec.length) { location.hash = m.spec[0].route; return; }
      if (!m.tax.length) { location.hash = searchHash; return; }         // nothing -> empty results page
      if (m.tax.length === 1) { location.hash = m.tax[0].route; return; }
      // clear leader (local score gap) -> straight in; else the results page
      var nodes = localNodes(q).filter(function (n) { return n.t !== "spec"; });
      var best = nodes[0], second = nodes[1];
      var bs = best ? scoreNode(q, best) : 0, ss = second ? scoreNode(q, second) : 0;
      if (best && (!second || bs <= ss - 6) && best.handle === m.tax[0].handle) { location.hash = best.route; return; }
      location.hash = searchHash;                                        // ambiguous -> did-you-mean page
    });
  }
  // Results page for #/s/<q> (a real route: reachable by back/forward + reload).
  // Renders did-you-mean / empty; never redirects, so no back-button loop.
  function viewSearchResults(q) {
    q = (q || "").trim(); if (!q) { location.hash = "#/"; return; }
    var exact = maps.bySku[q.toUpperCase().replace(/\s+/g, "")];
    if (exact) { gotoPDP(exact.sku); return; }
    var my = ++SRCH.token;
    didYouMean(q, null); // instant local so the page paints before Boost returns
    boostSearch(q).then(function (boost) {
      if (my !== SRCH.token || decodeURIComponent((location.hash.match(/^#\/s\/(.+)$/) || [])[1] || "") !== q) return;
      var m = mergeRoute(q, boost);
      didYouMean(q, m.tax.slice(0, 3));
    });
  }
  function wireSearch(root) {
    var input = $(".fv3-search input", root), box = $(".fv3-suggest", root);
    var timer, ctrl, activeIdx = -1, items = [], suggestToken = 0;
    function close() {
      // bump the token + abort the in-flight Boost enrich so a late response can
      // never re-open the panel after Enter routed away (QA R1 finding 3: the
      // panel leaked open across every subsequent navigation until Escape)
      suggestToken++;
      if (ctrl && ctrl.abort) ctrl.abort();
      clearTimeout(timer);
      box.classList.remove("open"); box.innerHTML = ""; activeIdx = -1; items = [];
    }
    window.addEventListener("hashchange", close); // belt-and-braces: no panel survives a navigation
    // shared hook for compose-release paths: emptying the BOX is part of releasing
    // a compose term, otherwise Enter instantly re-composes what the user just
    // cleared (QA R2 finding). close() also kills pending suggest state.
    SRCH.reset = function () { input.value = ""; close(); };
    function renderSuggest(html, wire) {
      box.innerHTML = html; box.classList.add("open"); activeIdx = -1;
      Array.prototype.forEach.call(box.querySelectorAll(".fv3-sug[data-i]"), function (n) {
        n.addEventListener("mousedown", function (e) { e.preventDefault(); pick(parseInt(n.getAttribute("data-i"), 10)); });
      });
    }
    // In-sheet compose suggestions: match within the current sheet's rows.
    function suggestInSheet(q) {
      var rows = sheetState.rows.filter(function (p) { return prodMatchesText(p, q); }).slice(0, 6);
      items = [];
      var famName = sheetState.fam.display;
      var html = '<div class="grp"><div class="glabel">In ' + esc(famName) + '</div>';
      if (rows.length) {
        rows.forEach(function (p) {
          items.push({ kind: "sku", sku: p.sku });
          html += '<div class="fv3-sug" role="option" data-i="' + (items.length - 1) + '"><span><code>' + esc(p.sku) + '</code> ' +
            '<span class="path">' + esc(p.title.split(",")[0]) + '</span></span><span class="price">' + priceOrQuote(p) + '</span></div>';
        });
      } else {
        html += '<div class="fv3-sug"><span class="path">No matches in ' + esc(famName) + '</span></div>';
      }
      html += '</div><div class="grp"><div class="fv3-sug escape" role="option" data-i="' + items.length + '"><span>Search all categories for &ldquo;' + esc(q) + '&rdquo;</span><span class="price">&rarr;</span></div></div>';
      items.push({ kind: "escape", q: q });
      renderSuggest(html);
    }
    function suggestGlobal(q, boost) {
      var m = mergeRoute(q, boost || null);
      var taxNodes = m.tax.slice(0, 3), specNodes = m.spec.slice(0, 3);
      var uq = q.toUpperCase().replace(/\s+/g, ""), skus = [];
      if (uq.length >= 2) {
        skus = IDX.products.filter(function (p) { return p.sku.toUpperCase().replace(/\s+/g, "").indexOf(uq) >= 0; })
          .sort(function (a, b) { return a.sku.length - b.sku.length; }).slice(0, 3);
      }
      items = []; var html = "";
      if (taxNodes.length) {
        html += '<div class="grp"><div class="glabel">Categories</div>';
        taxNodes.forEach(function (nd) {
          items.push({ kind: "node", route: nd.route });
          html += '<div class="fv3-sug" role="option" data-i="' + (items.length - 1) + '"><span><span>' + esc(nd.n) + '</span>' +
            (nd.path ? ' <span class="path">' + esc(nd.path) + '</span>' : '') + '</span>' +
            (nd.count != null ? '<span class="price">' + nd.count + '</span>' : '') + '</div>';
        });
        html += '</div>';
      }
      if (specNodes.length) {
        html += '<div class="grp"><div class="glabel">Filter by spec</div>';
        specNodes.forEach(function (nd) {
          items.push({ kind: "node", route: nd.route });
          html += '<div class="fv3-sug" role="option" data-i="' + (items.length - 1) + '"><span><span>' + esc(nd.n) + '</span>' +
            ' <span class="path">' + esc(nd.path) + '</span></span><span class="price">' + nd.count + '</span></div>';
        });
        html += '</div>';
      }
      if (skus.length) {
        html += '<div class="grp"><div class="glabel">Part numbers</div>';
        skus.forEach(function (p) {
          items.push({ kind: "sku", sku: p.sku });
          html += '<div class="fv3-sug" role="option" data-i="' + (items.length - 1) + '"><span><code>' + esc(p.sku) + '</code> ' +
            '<span class="path">' + esc(p.title.split(",")[0]) + '</span></span><span class="price">' + priceOrQuote(p) + '</span></div>';
        });
        html += '</div>';
      }
      if (!items.length) { html = '<div class="grp"><div class="fv3-sug"><span class="path">No matching part or category</span></div></div>'; }
      renderSuggest(html);
    }
    function suggest(q) {
      q = q.trim(); if (q.length < 1) { close(); return; }
      // Always global search (same as the landing page) - never scope suggestions
      // to the current category. The filter rail handles in-category narrowing.
      suggestGlobal(q, null);                                 // instant local
      // async Boost enrich, guarded so a stale response never renders
      var my = ++suggestToken;
      if (ctrl) ctrl.abort && ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      boostSearch(q, ctrl ? ctrl.signal : undefined).then(function (boost) {
        if (my !== suggestToken || input.value.trim() !== q) return;
        if (boost.families.length || boost.skus.length) suggestGlobal(q, boost);
      });
    }
    function pick(i) {
      var it = items[i]; if (!it) return;
      close(); input.blur();
      if (it.kind === "sku") gotoPDP(it.sku);
      else if (it.kind === "escape") escapeCompose(it.q); // full reset: facets + compose (QA R1 finding 5)
      else location.hash = it.route;
    }
    function commit() {
      var q = input.value.trim();
      if (!q) { close(); return; }
      var exact = maps.bySku[q.toUpperCase().replace(/\s+/g, "")];
      if (exact) { close(); gotoPDP(exact.sku); return; }        // full SKU always -> PDP
      close(); runGlobalSearch(q);                               // global, same as the landing page
    }
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value; timer = setTimeout(function () { suggest(q); }, 200);
    });
    input.addEventListener("keydown", function (e) {
      var rows = box.querySelectorAll(".fv3-sug[data-i]");
      if (e.key === "ArrowDown") { e.preventDefault(); activeIdx = Math.min(items.length - 1, activeIdx + 1); paint(rows); }
      else if (e.key === "ArrowUp") { e.preventDefault(); activeIdx = Math.max(-1, activeIdx - 1); paint(rows); }
      else if (e.key === "Enter") { if (activeIdx >= 0) { e.preventDefault(); pick(activeIdx); } else commit(); }
      else if (e.key === "Escape") { close(); }
    });
    input.addEventListener("fv3commit", function () { close(); runGlobalSearch(input.value); }); // quicklinks -> global
    function paint(rows) { Array.prototype.forEach.call(rows, function (n) { n.classList.toggle("active", parseInt(n.getAttribute("data-i"), 10) === activeIdx); }); }
    input.addEventListener("blur", function () { setTimeout(close, 140); });
  }
  function didYouMean(q, nodes) {
    if (nodes == null) nodes = localNodes(q).filter(function (n) { return n.t !== "spec"; }).slice(0, 3); // instant local
    render(function (shell) {
      var w = el("div", "fv3-crumb", '<a href="#/">Home</a><span class="sep">/</span><b>Search</b>');
      shell.appendChild(w);
      var box = el("div"); box.style.padding = "24px 22px 50px"; box.style.maxWidth = "760px";
      if (!nodes.length) {
        box.innerHTML = '<h2 style="color:var(--navy);font-size:19px;margin:0 0 8px">No match for "' + esc(q) + '"</h2>' +
          '<p style="color:var(--mut);font-size:14px">Try a part number like SFN-AR-1013, or a category like autosampler vials.</p>';
      } else {
        var h = '<h2 style="color:var(--navy);font-size:19px;margin:0 0 4px">Did you mean</h2>' +
          '<p style="color:var(--mut);font-size:13.5px;margin:0 0 16px">Pick a category to drill into. Filtrous routes search into the catalog, not a results list.</p>' +
          '<div style="display:flex;flex-direction:column;gap:9px">';
        nodes.forEach(function (nd) {
          h += '<a class="fv3-tile" href="' + esc(nd.route) + '" style="padding:14px 16px"><div class="tt">' + esc(nd.n) + '</div>' +
            '<div class="tc">' + esc(nd.path || "Department") + (nd.count != null ? ' &middot; ' + nd.count + ' items' : '') + '</div></a>';
        });
        h += '</div>'; box.innerHTML = h;
      }
      shell.appendChild(box);
    });
  }
  function gotoPDP(sku) {
    var p = maps.bySku[sku.toUpperCase()];
    if (CFG.inApp || !p) { location.hash = "#/p/" + encodeURIComponent(sku); }
    else { window.location.href = CFG.productBase + p.handle; }
  }
  // href for a product link (in-app hash or real product URL) - anchors carry
  // real hrefs so middle-click / open-in-new-tab work (QA R1 prose note)
  function pdpHref(p) {
    return (CFG.inApp || !p.handle) ? "#/p/" + encodeURIComponent(p.sku) : CFG.productBase + p.handle;
  }

  /* ---------------- render helpers ---------------- */
  function render(bodyFn) {
    var shell = $(".fv3-shell", MOUNT);
    shell.innerHTML = "";
    bodyFn(shell);
    window.scrollTo(0, 0);
  }
  function crumb(parts) {
    var w = el("div", "fv3-crumb"); var h = "";
    parts.forEach(function (p, i) {
      if (i) h += '<span class="sep">/</span>';
      if (p.route) h += '<a href="' + esc(p.route) + '">' + esc(p.label) + '</a>';
      else h += '<b>' + esc(p.label) + '</b>';
    });
    w.innerHTML = h; return w;
  }

  /* ---------------- home: full directory of ALL departments (category separators) ---------------- */
  function viewHome() {
    render(function (shell) {
      // intro spans the FULL width above both columns, so the rail ("Departments")
      // and the first department section start on the same top line (David 7/17:
      // rail didn't align with the product column when each held its own heading)
      var intro = el("div", "fv3-home-intro");
      intro.appendChild(el("h2", null, "Shop by category"));
      shell.appendChild(intro);
      var sorter = el("div", "fv3-sorter");
      // rail label is "Category" (David 7/18 item 9); the 7 big buckets are the
      // categories, the umbrella tiles inside are the families' groupings.
      var rail = el("nav", "fv3-rail"); rail.setAttribute("aria-label", "Category");
      function railScroll(b, id) {
        b.addEventListener("click", function () {
          var sec = document.getElementById(id);
          if (sec) sec.scrollIntoView({ behavior: "smooth", block: "start" });
          Array.prototype.forEach.call(rail.querySelectorAll("button"), function (x) { x.removeAttribute("aria-current"); });
          b.setAttribute("aria-current", "true");
        });
      }
      IDX.departments.forEach(function (d, i) {
        var n = 0; d.categories.forEach(function (c) { c.leaves.forEach(function (lf) { n += lf.count; }); });
        var b = el("button", null, '<span>' + esc(d.name) + '</span><span class="n">' + n + '</span>');
        if (i === 0) b.setAttribute("aria-current", "true");
        railScroll(b, "fv3-dept-" + d.slug);
        rail.appendChild(b);
      });
      // "New Products" gets its own rail slot + section (David 7/18 item 9). Space
      // reserved now; it populates once products carry a "new" tag/metafield.
      var nb = el("button", "fv3-rail-new", '<span>New Products</span>');
      railScroll(nb, "fv3-dept-new-products");
      rail.appendChild(nb);
      sorter.appendChild(rail);

      var center = el("div", "fv3-center");
      IDX.departments.forEach(function (d) {
        var block = el("section", "fv3-dept-block");
        block.id = "fv3-dept-" + d.slug;
        block.appendChild(el("h2", "fv3-dept-h", esc(d.name)));
        // ONE umbrella tile per category (David 7/18 item 1: condense - no more
        // single-part cards). Single-leaf category -> straight to its sheet;
        // multi-leaf -> explodes into its families in place.
        var tiles = el("div", "fv3-tiles");
        d.categories.forEach(function (c) {
          var n = 0, img = null;
          c.leaves.forEach(function (lf) {
            n += lf.count;
            if (!img) { var prods = maps.byFamily[lf.handle] || []; for (var k = 0; k < prods.length; k++) { if (prods[k].image) { img = prods[k].image; break; } } }
          });
          var single = c.leaves.length === 1;
          var a = el("a", "fv3-tile");
          a.href = single ? "#/f/" + c.leaves[0].handle : "#/d/" + d.slug + "/" + encodeURIComponent(c.name);
          var art = img
            ? '<div class="art"><img src="' + esc(img) + '" alt="" loading="lazy" /></div>'
            : '<div class="art ph-art"><span class="ph">' + esc(c.name) + '</span></div>';
          var sub = single ? (n + ' part' + (n === 1 ? '' : 's'))
            : (c.leaves.length + ' families &middot; ' + n + ' parts');
          a.innerHTML = art + '<div class="tbody"><div class="tt">' + esc(c.name) +
            '</div><div class="tc">' + sub + '</div></div>';
          tiles.appendChild(a);
        });
        block.appendChild(tiles);
        center.appendChild(block);
      });
      // New Products placeholder section (empty state until a "new" flag exists)
      var np = el("section", "fv3-dept-block"); np.id = "fv3-dept-new-products";
      np.appendChild(el("h2", "fv3-dept-h", "New Products"));
      np.appendChild(el("div", "fv3-newempty", "New arrivals will appear here as they land in the catalog."));
      center.appendChild(np);
      sorter.appendChild(center);
      shell.appendChild(sorter);
    });
  }

  /* ---------------- quality page (#/quality) ----------------
     Destination for the brand strip's "See how we QC" CTA - a dead brand CTA is a
     QA finding (drive script: no dead cards). Claims here are ONLY the standing
     commitments David ratified in the BOOM mock's trust bar; nothing invented. */
  function viewQuality() {
    render(function (shell) {
      shell.appendChild(crumb([{ label: "Home", route: "#/" }, { label: "Quality" }]));
      var box = el("div", "fv3-quality");
      box.innerHTML =
        '<h2>How we QC</h2>' +
        '<p>These are the standing commitments behind every part in the catalog.</p>' +
        '<ul>' +
        '<li><b>COA on every lot.</b> A certificate of analysis accompanies every lot we ship.</li>' +
        '<li><b>Same-day shipping.</b> In-stock orders placed before the daily cutoff ship the same day.</li>' +
        '<li><b>Net-30 for labs.</b> Qualified labs order on Net-30 terms.</li>' +
        '</ul>' +
        '<a class="fv3-qback" href="#/">Browse the catalog</a>';
      shell.appendChild(box);
    });
  }

  /* ---------------- sorter: department view (category tiles) ---------------- */
  function viewDept(slug, catFocus) {
    var dept = IDX.departments.filter(function (d) { return d.slug === slug; })[0] || IDX.departments[0];
    render(function (shell) {
      var sorter = el("div", "fv3-sorter");
      // rail
      var rail = el("nav", "fv3-rail"); rail.setAttribute("aria-label", "Departments");
      IDX.departments.forEach(function (d) {
        var n = 0; d.categories.forEach(function (c) { c.leaves.forEach(function (lf) { n += lf.count; }); });
        var b = el("button", null, '<span>' + esc(d.name) + '</span><span class="n">' + n + '</span>');
        if (d.slug === dept.slug) b.setAttribute("aria-current", "true");
        b.addEventListener("click", function () { location.hash = "#/d/" + d.slug; });
        rail.appendChild(b);
      });
      sorter.appendChild(rail);
      // breadcrumb spans full width, aligned under the wordmark (not indented into
      // the column). Every drill level gets a trail, including the department
      // itself (QA R1 finding 2)
      if (catFocus) {
        shell.appendChild(crumb([{ label: "Home", route: "#/" }, { label: dept.name, route: "#/c/" + dept.slug }, { label: catFocus }]));
      } else {
        shell.appendChild(crumb([{ label: "Home", route: "#/" }, { label: dept.name }]));
      }
      // center
      var center = el("div", "fv3-center");
      if (catFocus) {
        // EXPLODE: one category -> its sub-type leaf tiles
        var cat = dept.categories.filter(function (c) { return c.name === catFocus; })[0];
        center.appendChild(el("h2", null, esc(catFocus)));
        center.appendChild(tileGrid(cat ? cat.leaves : [], true));
      } else {
        center.appendChild(el("h2", null, esc(dept.name)));
        center.appendChild(catTileGrid(dept));
      }
      sorter.appendChild(center);
      shell.appendChild(sorter);
    });
  }
  function catTileGrid(dept) {
    var g = el("div", "fv3-tiles");
    dept.categories.forEach(function (c) {
      var n = 0; c.leaves.forEach(function (lf) { n += lf.count; });
      var single = c.leaves.length === 1;
      var a = el("a", "fv3-tile");
      // single-leaf category jumps straight to its sheet; multi-leaf explodes in place
      a.href = single ? "#/f/" + c.leaves[0].handle : "#/d/" + dept.slug + "/" + encodeURIComponent(c.name);
      var subline = single ? (n + ' part' + (n === 1 ? '' : 's'))
        : (c.leaves.length + ' families &middot; ' + n + ' parts');
      a.innerHTML = '<div class="art"><span class="ph">' + esc(c.name) + '</span></div>' +
        '<div class="tbody"><div class="tt">' + esc(c.name) + '</div><div class="tc">' + subline + '</div></div>';
      g.appendChild(a);
    });
    return g;
  }
  function tileGrid(leaves, toSheet, dept, cat) {
    var g = el("div", "fv3-tiles");
    leaves.forEach(function (lf) {
      var a = el("a", "fv3-tile");
      a.href = "#/f/" + lf.handle;
      a.innerHTML = '<div class="art"><span class="ph">' + esc(lf.display) + '</span></div>' +
        '<div class="tbody"><div class="tt">' + esc(lf.display) + '</div>' +
        '<div class="tc">' + lf.count + ' part' + (lf.count === 1 ? '' : 's') + '</div></div>';
      g.appendChild(a);
    });
    return g;
  }

  /* ---------------- the sheet ---------------- */
  // Low-signal spec columns never shown as sheet columns (David 7/18 item 3).
  var SUPPRESS_COLS = /^(write[- ]?on[- ]?patch)$/i;
  var sheetState = null;
  function viewSheet(handle, prefilter) {
    var fam = IDX.families[handle];
    if (!fam) { location.hash = "#/"; return; }
    var rows = (maps.byFamily[handle] || []).slice();
    var cols = fam.columns || [];
    // filterable facets: build value maps
    var facets = cols.map(function (c) {
      var isNum = /number/.test(c.type);
      var vals = {};
      var nums = [];
      rows.forEach(function (p) {
        var v = p.specs[c.key];
        if (v == null) return;
        if (isNum) { nums.push(+v); }
        vals[v] = (vals[v] || 0) + 1;
      });
      return { key: c.key, label: c.label, type: c.type, isNum: isNum, vals: vals,
        min: nums.length ? Math.min.apply(null, nums) : 0, max: nums.length ? Math.max.apply(null, nums) : 0,
        distinct: Object.keys(vals).length };
    }).filter(function (f) { return f.distinct > 1; }); // hide single-value / empty facets

    sheetState = { handle: handle, fam: fam, cols: cols, rows: rows, facets: facets,
      sel: {}, range: {}, sort: null, groupCol: pickGroupCol(handle, cols, rows) };
    // pre-applied filter from a search "Filter by spec" pick (e.g. layers=Double Layer)
    if (prefilter && prefilter.key) {
      var hasFacet = facets.some(function (f) { return f.key === prefilter.key; });
      if (hasFacet) { sheetState.sel[prefilter.key] = {}; sheetState.sel[prefilter.key][prefilter.val] = 1; }
    }
    render(function (shell) {
      // breadcrumb spans full width, aligned under the wordmark
      shell.appendChild(crumb([{ label: "Home", route: "#/" },
        // Dept + category crumbs return to the HOME landing page with this department
        // preselected (#/c/<slug> → home-families preselectFromUrl). David 2026-07-29.
        { label: fam.department, route: "#/c/" + fam.dept_slug },
        { label: fam.category, route: "#/c/" + fam.dept_slug },
        { label: fam.display }]));
      var sheet = el("div", "fv3-sheet");
      // mobile: facets collapse behind a toggle so the table leads (QA R1 finding
      // 8: the full facet panel pushed every product row below the fold at 375px).
      // Hidden on desktop via CSS; the count badge updates in paintRows.
      var ftog = el("button", "fv3-ftoggle");
      ftog.setAttribute("aria-expanded", "false");
      ftog.innerHTML = '<span>Filters</span><span class="fcount"></span><span class="car">&#9662;</span>';
      ftog.addEventListener("click", function () {
        var open = sheet.classList.toggle("filters-open");
        ftog.setAttribute("aria-expanded", open ? "true" : "false");
      });
      sheet.appendChild(ftog);
      sheet.appendChild(buildFilters());
      var main = el("div", "fv3-sheet-main");
      var head = el("div", "fv3-sheet-head");
      head.innerHTML = '<h1>' + esc(fam.display) + '</h1>';
      var right = el("div"); right.style.display = "flex"; right.style.gap = "12px"; right.style.alignItems = "center";
      right.innerHTML = '<span class="fv3-count"></span>';
      var sortSel = el("select", "fv3-sort");
      sortSel.innerHTML = '<option value="">Sort: Part number</option>' +
        '<option value="price">Price low to high</option>' +
        '<option value="-price">Price high to low</option>' +
        cols.filter(function (c) { return /number/.test(c.type); }).map(function (c) { return '<option value="s:' + c.key + '">' + esc(c.label) + '</option>'; }).join("");
      sortSel.addEventListener("change", function () { sheetState.sort = sortSel.value; paintRows(); });
      right.appendChild(sortSel);
      head.appendChild(right);
      main.appendChild(head);
      main.appendChild(el("div", "fv3-compose")); // in-sheet search banner (populated by paintRows)
      var wrap = el("div", "fv3-tablewrap"); wrap.appendChild(el("table", "fv3-table"));
      main.appendChild(wrap);
      sheet.appendChild(main);
      shell.appendChild(sheet);
      paintRows();
    });
  }
  function buildFilters() {
    var s = sheetState;
    // collapse state: first 4 facets open, rest closed; facets with an active
    // selection force-open. Space rule (David 2026-07-08): rail never exceeds
    // the page - dense rows + collapsed tail + sticky internal scroll backstop.
    if (!s.uiCollapsed) {
      s.uiCollapsed = {};
      s.facets.forEach(function (fc, i) { s.uiCollapsed[fc.key] = i >= 4; });
    }
    s.uiShowAll = s.uiShowAll || {};
    var f = el("aside", "fv3-filters"); f.setAttribute("aria-label", "Filters");
    var head = el("div", "fhead"); head.innerHTML = '<h4>Filter</h4>';
    // Clear wipes EVERYTHING narrowing the sheet - facets AND an active compose
    // term (QA R1 finding 7: Clear kept the compose term and bricked the sheet)
    var clr = el("button", "clear", "Clear"); clr.addEventListener("click", function () { if (s.text && SRCH.reset) SRCH.reset(); s.sel = {}; s.range = {}; s.text = ""; rebuildFilters(); paintRows(); });
    head.appendChild(clr); f.appendChild(head);
    s.facets.forEach(function (fc) {
      var active = (s.sel[fc.key] && Object.keys(s.sel[fc.key]).length) || s.range[fc.key];
      var open = active ? true : !s.uiCollapsed[fc.key];
      var box = el("div", "fv3-facet" + (open ? "" : " closed"));
      var hd = el("button", "fh");
      hd.setAttribute("aria-expanded", open ? "true" : "false");
      hd.innerHTML = '<span>' + esc(fc.label) + (active ? ' <i class="dot"></i>' : '') + '</span><span class="car">' + (open ? '&#9662;' : '&#9656;') + '</span>';
      hd.addEventListener("click", function () {
        s.uiCollapsed[fc.key] = open; // toggling from current
        rebuildFilters();
      });
      box.appendChild(hd);
      if (!open) { f.appendChild(box); return; }
      if (fc.isNum) {
        // sliders snap between the DISCRETE values that exist in this family
        // (0.1 -> 0.22 -> 0.45 -> 5), never a free-floating range (David 2026-07-08)
        var stops = Object.keys(fc.vals).map(parseFloat)
          .filter(function (n) { return !isNaN(n); })
          .sort(function (a, b) { return a - b; })
          .filter(function (n, i, arr) { return i === 0 || n !== arr[i - 1]; });
        var nearestIdx = function (v) {
          var best = 0, bd = Infinity;
          stops.forEach(function (sv, i) { var d = Math.abs(sv - v); if (d < bd) { bd = d; best = i; } });
          return best;
        };
        var cur = s.range[fc.key] || [stops[0], stops[stops.length - 1]];
        var ia = nearestIdx(cur[0]), ib = nearestIdx(cur[1]);
        var wrapR = el("div", "fv3-range");
        var lo = el("input"); lo.type = "range"; lo.min = 0; lo.max = stops.length - 1; lo.step = 1; lo.value = ia;
        var hi = el("input"); hi.type = "range"; hi.min = 0; hi.max = stops.length - 1; hi.step = 1; hi.value = ib;
        var rv = el("div", "rv", fmtNum(stops[ia]) + " to " + fmtNum(stops[ib]));
        function upd() {
          var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
          s.range[fc.key] = [stops[a], stops[b]];
          rv.textContent = fmtNum(stops[a]) + " to " + fmtNum(stops[b]);
          paintRows();
        }
        lo.addEventListener("input", upd); hi.addEventListener("input", upd);
        wrapR.appendChild(lo); wrapR.appendChild(hi);
        // tick labels: all stops when they fit, else first/last
        var ticks = el("div", "ticks");
        (stops.length <= 6 ? stops : [stops[0], stops[stops.length - 1]]).forEach(function (sv) {
          ticks.appendChild(el("span", null, esc(fmtNum(sv))));
        });
        wrapR.appendChild(ticks);
        wrapR.appendChild(rv);
        box.appendChild(wrapR);
      } else {
        var opts = el("div", "opts");
        var counts = liveCounts(fc.key); // counts given OTHER active filters
        var allVals = Object.keys(fc.vals).sort(sortVals);
        // long lists: show 6 + "Show all" (selected values always stay visible)
        var truncated = allVals.length > 8 && !s.uiShowAll[fc.key];
        var visible = truncated
          ? allVals.filter(function (v, i) { return i < 6 || (s.sel[fc.key] && s.sel[fc.key][v]); })
          : allVals;
        visible.forEach(function (v) {
          var c = counts[v] || 0;
          var lab = el("label", "fv3-opt" + (c === 0 ? " off" : ""));
          var cb = el("input"); cb.type = "checkbox"; cb.checked = !!(s.sel[fc.key] && s.sel[fc.key][v]);
          cb.addEventListener("change", function () {
            s.sel[fc.key] = s.sel[fc.key] || {};
            if (cb.checked) s.sel[fc.key][v] = 1; else delete s.sel[fc.key][v];
            rebuildFilters(); paintRows();
          });
          lab.appendChild(cb);
          lab.appendChild(el("span", null, esc(v)));
          lab.appendChild(el("span", "oc", String(c)));
          opts.appendChild(lab);
        });
        if (allVals.length > 8) {
          var more = el("button", "fv3-more", truncated ? "Show all " + allVals.length : "Show fewer");
          more.addEventListener("click", function () { s.uiShowAll[fc.key] = truncated; rebuildFilters(); });
          opts.appendChild(more);
        }
        box.appendChild(opts);
      }
      f.appendChild(box);
    });
    return f;
  }
  function rebuildFilters() {
    var old = $(".fv3-filters", MOUNT); if (old) old.replaceWith(buildFilters());
  }
  function sortVals(a, b) { var na = parseFloat(a), nb = parseFloat(b); if (!isNaN(na) && !isNaN(nb)) return na - nb; return a < b ? -1 : 1; }
  function fmtNum(n) { return (Math.round(n * 100) / 100).toString(); }
  // count how many rows each value of key would yield given the OTHER active filters
  function liveCounts(key) {
    var s = sheetState, out = {};
    var subset = s.rows.filter(function (p) { return matches(p, key); });
    subset.forEach(function (p) { var v = p.specs[key]; if (v != null) out[v] = (out[v] || 0) + 1; });
    return out;
  }
  // in-sheet text match (compose): every query token appears in the product's
  // searchable string (sku + title + spec values). Cached per product.
  function prodMatchesText(p, q) {
    var toks = norm(q).split(" ").filter(Boolean); if (!toks.length) return true;
    if (!p.__hay) {
      var sv = [];
      for (var kk in p.specs) { var vv = p.specs[kk]; if (vv != null && vv !== true) sv.push(vv); }
      p.__hay = norm(p.sku + " " + p.title + " " + sv.join(" "));
    }
    for (var i = 0; i < toks.length; i++) { if (p.__hay.indexOf(toks[i]) < 0) return false; }
    return true;
  }
  function matches(p, exceptKey) {
    var s = sheetState;
    if (s.text && !prodMatchesText(p, s.text)) return false; // compose: text filter always applies
    for (var k in s.sel) {
      if (k === exceptKey) continue;
      var chosen = s.sel[k]; var any = Object.keys(chosen);
      if (any.length && !(p.specs[k] != null && chosen[p.specs[k]])) return false;
    }
    for (var rk in s.range) {
      if (rk === exceptKey) continue;
      var r = s.range[rk], v = p.specs[rk];
      if (v == null || +v < r[0] || +v > r[1]) return false;
    }
    return true;
  }
  // Major sub-category axis per family: explicit picks first (David 2026-07-08:
  // syringe filters split by construction code), else first enum column with
  // 2-8 distinct values covering >=60% of rows. null = flat sheet.
  var GROUP_BY = {
    "syringe-filters-v2": "construction_code",
    "single-layer-syringe-filters-v2": "construction_code",
    "multi-layer-syringe-filters-v2": "construction_code",
    "capillaries-v2": "capillary_type",
    "membrane-filters-v2": "membrane",
    "vacuum-filters-v2": "membrane"
  };
  function pickGroupCol(handle, cols, rows) {
    var find = function (key) {
      for (var i = 0; i < cols.length; i++) if (cols[i].key === key) return cols[i];
      return null;
    };
    var ok = function (c) {
      if (!c || c.type !== "enum") return false;
      var vals = {}, filled = 0;
      rows.forEach(function (p) { var v = p.specs[c.key]; if (v != null) { filled++; vals[v] = 1; } });
      var n = Object.keys(vals).length;
      return n >= 2 && n <= 8 && filled >= rows.length * 0.6;
    };
    var exp = find(GROUP_BY[handle]);
    if (ok(exp)) return exp;
    for (var i = 0; i < cols.length; i++) if (ok(cols[i])) return cols[i];
    return null;
  }
  function currentRows() {
    var s = sheetState;
    var out = s.rows.filter(function (p) { return matches(p, null); });
    var so = s.sort;
    if (so === "price") out.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    else if (so === "-price") out.sort(function (a, b) { return parseFloat(b.price) - parseFloat(a.price); });
    else if (so && so.indexOf("s:") === 0) { var k = so.slice(2); out.sort(function (a, b) { return (a.specs[k] == null ? 1e9 : +a.specs[k]) - (b.specs[k] == null ? 1e9 : +b.specs[k]); }); }
    else out.sort(function (a, b) { return a.sku < b.sku ? -1 : 1; });
    return out;
  }
  function paintRows() {
    var s = sheetState, tbl = $(".fv3-table", MOUNT), rows = currentRows();
    var cnt = $(".fv3-count", MOUNT); if (cnt) cnt.innerHTML = "<b>" + rows.length + "</b> of " + s.rows.length + " parts";
    // mobile filter-toggle badge: number of active facets (+ compose term)
    var fcnt = $(".fv3-ftoggle .fcount", MOUNT);
    if (fcnt) {
      var nAct = Object.keys(s.sel).filter(function (k) { return Object.keys(s.sel[k]).length; }).length +
        Object.keys(s.range).length + (s.text ? 1 : 0);
      fcnt.textContent = nAct ? String(nAct) : "";
    }
    // compose banner: persists the whole time a compose term is active, with a
    // one-click reset AND the full-reset global escape (QA R1 findings 5 + 7)
    var cmp = $(".fv3-compose", MOUNT);
    if (cmp) {
      if (s.text) {
        cmp.innerHTML = '<span>Showing matches for &ldquo;' + esc(s.text) + '&rdquo; within ' + esc(s.fam.display) +
          '</span><span class="acts"><button class="fv3-clearsearch" type="button">Clear search</button>' +
          '<button class="fv3-escape" type="button">Search all categories instead</button></span>';
        cmp.classList.add("on");
        cmp.querySelector(".fv3-clearsearch").addEventListener("click", function () { clearSheetText(); });
        cmp.querySelector(".fv3-escape").addEventListener("click", function () { escapeCompose(s.text); });
      } else { cmp.innerHTML = ""; cmp.classList.remove("on"); }
    }
    // column set = family columns, minus (a) low-signal suppressed columns and
    // (b) any column that is null for EVERY part in the family (David 7/18 item 3:
    // e.g. Thread/Size is all-null on Headspace Vials; Write-On Patch is noise).
    var specCols = s.cols.filter(function (c) {
      if (SUPPRESS_COLS.test(String(c.label).replace(/\s+/g, " ").trim())) return false;
      return s.rows.some(function (p) {
        var v = p.specs[c.key];
        return v != null && v !== "" && !(Array.isArray(v) && !v.length);
      });
    });
    // spec value columns are centered under their heading (David 7/18 item 4)
    // Drop the entire "Add" column when NO row is purchasable — every row is
    // Call-for-Quote or sold out (David 2026-07-28). Mixed tables keep the column.
    var noAdd = rows.length > 0 && rows.every(function (p) { return isOskQuote(p) || !inStock(p); });
    var thead = '<thead><tr><th class="fv3-thumbh"></th><th>Part number</th><th>Product</th>';
    specCols.forEach(function (c) { thead += '<th class="spec">' + esc(c.label) + "</th>"; });
    thead += '<th class="num" style="text-align:center !important">Price</th><th style="text-align:center !important;padding-left:8px !important;padding-right:8px !important">Stock</th>' + (noAdd ? '' : '<th>Add</th>') + '</tr></thead>';
    var body = "";
    var span = specCols.length + (noAdd ? 5 : 6);
    if (!rows.length) {
      // unmissable 0-state: name the compose term when one is active and offer a
      // one-click way out (QA R1 prose note: compose 0-state must self-explain)
      body = s.text
        ? '<tr><td colspan="' + span + '"><div class="fv3-empty">No matches for &ldquo;' + esc(s.text) + '&rdquo; within these filters. ' +
          '<a class="fv3-view" data-clearsearch="1">Clear search</a> &nbsp; <a class="fv3-view" data-escape="1">Search all categories instead</a></div></td></tr>'
        : '<tr><td colspan="' + span + '"><div class="fv3-empty">No parts match these filters. <a class="fv3-view" data-clear="1">Clear filters</a></div></td></tr>';
    }
    // group by the family's major sub-category (headers inside the sheet, like the
    // front-page separators) whenever >1 group remains after filtering
    var gc = s.groupCol, grouped = null;
    if (gc && rows.length) {
      var buckets = {}, order = [];
      rows.forEach(function (p) {
        var v = p.specs[gc.key]; var lbl = v == null ? "Other" : String(v);
        if (!buckets[lbl]) { buckets[lbl] = []; order.push(lbl); }
        buckets[lbl].push(p);
      });
      if (order.length > 1) {
        order.sort(function (a, b) { if (a === "Other") return 1; if (b === "Other") return -1; return sortVals(a, b); });
        grouped = { buckets: buckets, order: order };
      }
    }
    var emitRow = function (p) {
      body += '<tr data-sku="' + esc(p.sku) + '">';
      // thumbnail cell (David 7/17: small product pic on every sheet row)
      body += '<td class="fv3-thumb">' + (p.image
        ? '<a href="' + esc(pdpHref(p)) + '" tabindex="-1"><img src="' + esc(p.image) + '" alt="" loading="lazy" /></a>'
        : '') + '</td>';
      body += '<td class="fv3-part">' + esc(p.sku) + '</td>';
      body += '<td class="fv3-pname"><a href="' + esc(pdpHref(p)) + '" title="' + esc(p.title) + '">' + esc(p.title) + '</a></td>';
      specCols.forEach(function (c) {
        var v = p.specs[c.key];
        body += '<td class="spec">' + (v == null ? '<span style="color:var(--faint)">-</span>' : esc(fmtSpec(v, c))) + '</td>';
      });
      body += '<td class="fv3-price num" style="text-align:center !important">' + priceOrQuote(p) + '</td>';
      body += '<td style="text-align:center !important">' + stockCell(p) + '</td>';
      if (!noAdd) {
        if (isOskQuote(p) || !inStock(p)) {
          body += '<td></td>'; // OSK or sold out: no qty stepper / Add button (David 2026-07-28)
        } else {
          body += '<td><div class="fv3-qadd"><input class="fv3-qty" type="number" min="1" value="1" aria-label="Quantity for ' + esc(p.sku) + '"' + (inStock(p) ? '' : ' disabled') + ' />' +
            '<button class="fv3-add" data-add="' + esc(p.sku) + '"' + (inStock(p) ? '' : ' disabled') + '>Add</button></div></td>';
        }
      }
      body += '</tr>';
    };
    if (grouped) {
      grouped.order.forEach(function (lbl) {
        body += '<tr class="fv3-group"><td colspan="' + span + '"><b>' + esc(lbl) + '</b><span class="gl">' + esc(gc.label) + '</span><span class="gn">' + grouped.buckets[lbl].length + ' part' + (grouped.buckets[lbl].length === 1 ? '' : 's') + '</span></td></tr>';
        grouped.buckets[lbl].forEach(emitRow);
      });
    } else {
      rows.forEach(emitRow);
    }
    tbl.innerHTML = thead + "<tbody>" + body + "</tbody>";
    // wire
    Array.prototype.forEach.call(tbl.querySelectorAll("[data-add]"), function (b) {
      b.addEventListener("click", function () {
        var p = maps.bySku[b.getAttribute("data-add").toUpperCase()];
        var qty = b.parentNode.querySelector(".fv3-qty").value;
        addToCart(p, qty, b);
      });
    });
    var clr = tbl.querySelector("[data-clear]");
    if (clr) clr.addEventListener("click", function () { if (sheetState.text && SRCH.reset) SRCH.reset(); sheetState.sel = {}; sheetState.range = {}; sheetState.text = ""; rebuildFilters(); paintRows(); });
    var cs = tbl.querySelector("[data-clearsearch]");
    if (cs) cs.addEventListener("click", function () { clearSheetText(); });
    var esb = tbl.querySelector("[data-escape]");
    if (esb) esb.addEventListener("click", function () { escapeCompose(sheetState.text); });
  }
  var UNIT_SUFFIX = { um: " um", mm: " mm", mL: " mL", uL: " uL", oz: " oz", mg: " mg", "in": '"', mil: " mil" };
  function fmtSpec(v, c) {
    if (v === true) return "Yes";
    var t = c.type || "";
    if (t.indexOf("number+unit:") === 0) { var u = t.slice(12); return v + (UNIT_SUFFIX[u] || " " + u); }
    return v;
  }
  function stockCell(p) {
    return inStock(p)
      ? '<span class="fv3-stock in"><span class="dotm"></span>In stock</span>'
      : '<span class="fv3-stock out"><span class="dotm"></span>Sold Out</span>';
  }

  // Back-in-stock capture on sold-out PDPs (David 2026-07-28). The green
  // "Email me when it's back" button toggles an email field; Enter (or Notify me)
  // sends the request to the store via Shopify's native contact form — no new app,
  // no marketing subscription. Backend/catalog untouched.
  function wireNotify(root, p) {
    var btn = $(".fv3-notify-btn", root), panel = $(".fv3-notify", root);
    if (!btn || !panel) return;
    var emailIn = $(".fv3-notify-email", panel), sendBtn = $(".fv3-notify-send", panel),
        msg = $(".fv3-notify-msg", panel), rowEl = $(".fv3-notify-row", panel);
    btn.addEventListener("click", function () {
      if (panel.hasAttribute("hidden")) { panel.removeAttribute("hidden"); if (emailIn) emailIn.focus(); }
      else { panel.setAttribute("hidden", ""); }
    });
    function submit() {
      var val = (emailIn.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) { msg.textContent = "Please enter a valid email."; msg.className = "fv3-notify-msg err"; emailIn.focus(); return; }
      sendBtn.disabled = true; emailIn.disabled = true;
      // Confirm IMMEDIATELY; the POST is fire-and-forget (opaque no-cors + ~2s Apps Script
      // round-trip made it look frozen - David 2026-07-29). Optimistic: low-stakes signup.
      if (rowEl) rowEl.style.display = "none";
      msg.textContent = "Success! We'll email you as soon as it's back."; msg.className = "fv3-notify-msg ok";
      notifyBackInStock(val, panel.getAttribute("data-sku") || p.sku, p.title).catch(function () {});
      // After 30s, revert to the email input so it's ready to use again (David 2026-07-29).
      setTimeout(function () {
        if (rowEl) rowEl.style.display = "";
        emailIn.disabled = false; emailIn.value = "";
        sendBtn.disabled = false;
        msg.textContent = ""; msg.className = "fv3-notify-msg";
      }, 30000);
    }
    if (sendBtn) sendBtn.addEventListener("click", submit);
    if (emailIn) emailIn.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); submit(); } });
  }
  // Destination for sold-out "notify me" requests. Set BACK_IN_STOCK_URL to a
  // Google Apps Script Web App /exec URL to log every request to a Google Sheet.
  // While it's empty we fall back to Shopify's contact form (emails the store).
  var BACK_IN_STOCK_URL = "https://script.google.com/a/macros/filtrous.com/s/AKfycbw4MCzrOm5uFPKA-XKUOIOC3iZGah-w2lQsAFVGnbgtbYc2-uR0urAleudcua-LW03T/exec";
  function notifyBackInStock(email, sku, title) {
    if (CFG.mock) return Promise.resolve(); // local harness: no backend
    if (BACK_IN_STOCK_URL) {
      // Fire-and-forget to the Google Sheet. Apps Script sends no CORS headers, so
      // use no-cors (opaque response) with text/plain to avoid a preflight; the
      // script timestamps + appends the row. We optimistically report success.
      return fetch(BACK_IN_STOCK_URL, {
        method: "POST", mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({ email: email, sku: sku || "", product: title || "" })
      }).then(function () {});
    }
    var fd = new FormData();
    fd.append("form_type", "contact");
    fd.append("utf8", "✓");
    fd.append("contact[name]", "Back-in-stock request");
    fd.append("contact[email]", email);
    fd.append("contact[body]", "Back-in-stock alert requested for " + (title || "") + " (SKU " + (sku || "") + ").");
    return fetch("/contact", { method: "POST", body: fd }).then(function (r) { if (!r.ok) throw new Error("contact " + r.status); });
  }

  /* Clearance BOGO — SKUs covered by the active "Buy One, Get One Free"
     automatic discount (scope collection: clearance-bogo-discount-scope-hidden,
     20 items). The PDP shows the BOGO line ONLY for these, so the 4 Promo items
     that are NOT in the discount don't advertise it. Keep in sync with that
     discount's scope collection. */
  var BOGO_SKUS = {
    "COV-12-0000":1,"PCV-96-0301":1,"WPR-11-2020":1,"WPR-11-2010":1,"CUF-00-0300":1,
    "MBP-08-1404":1,"COV-10-A000":1,"SPP-14-0005":1,"WPR-31-2003":1,"COV-96-RACK":1,
    "STM30-A-C":1,"TCE-11-1000":1,"ELM-03-4100":1,"RTX-TN-0050":1,"RTX-TN-1000":1,
    "RTX-HC-0300":1,"PTM-TN-0500":1,"PTM-TN-0050":1,"PTF-LS-0010":1,"CSS-10-5020":1
  };

  /* ---------------- PDP (balanced-A) ---------------- */
  function viewPDP(sku) {
    var p = maps.bySku[decodeURIComponent(sku).toUpperCase()];
    if (!p) { location.hash = "#/"; return; }
    var fam = IDX.families[p.primary_family] || {};
    render(function (shell) {
      // full trail incl. the category level, mirroring the sheet's crumb
      // (QA R1 prose: PDP crumb skipped the category)
      // Top row: breadcrumb (left) + a slot the section's placement script docks the
      // store-wide search into — top-right, under the header (David 2026-07-29, PDP only).
      var pdpTop = el("div", "fv3-pdp-top");
      pdpTop.appendChild(crumb([{ label: "Home", route: "#/" }].concat(fam.display ? [
        // Dept + category crumbs return to the HOME landing page with this department
        // preselected (#/c/<slug> → home-families preselectFromUrl). David 2026-07-29.
        { label: fam.department, route: "#/c/" + fam.dept_slug },
        { label: fam.category, route: "#/c/" + fam.dept_slug },
        { label: fam.display, route: "#/f/" + p.primary_family }
      ] : []).concat([{ label: p.sku }])));
      pdpTop.appendChild(el("div", "fv3-pdp-searchslot"));
      shell.appendChild(pdpTop);
      var pdp = el("div", "fv3-pdp");
      var grid = el("div", "fv3-pdp-grid");
      // gallery
      var g = el("div", "fv3-gallery");
      g.innerHTML = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="eager" fetchpriority="high" decoding="async" />' : '<span class="ph">' + esc(fam.display || "Filtrous") + '</span>';
      grid.appendChild(g);
      // buy column
      var buy = el("div", "fv3-buy");
      var rowsSpec = (fam.columns || []).filter(function (c) { return p.specs[c.key] != null; });
      // balanced-A (locked mock): part label -> mono part# -> title -> pack -> price
      // -> stock -> stepper+add -> spec table PINNED TO BOTTOM so columns end together
      var pack = p.specs.pack_qty && +p.specs.pack_qty > 1 ? +p.specs.pack_qty : null;
      var specHtml = rowsSpec.length ? '<table class="fv3-spec"><tbody>' +
        rowsSpec.map(function (c) { return '<tr><td>' + esc(c.label) + '</td><td>' + esc(fmtSpec(p.specs[c.key], c)) + '</td></tr>'; }).join("") +
        '</tbody></table>' : '';
      buy.innerHTML =
        '<div class="partlabel">Part number</div>' +
        '<div class="part">' + esc(p.sku) + '</div>' +
        '<h1>' + esc(p.title) + '</h1>' +
        (pack ? '<div class="pack">Pack of ' + pack + '</div>' : '') +
        (isOskQuote(p) ? '' : '<div class="pdp-price">' + money(p.price) + (pack ? ' <small>/ pack</small>' : '') + '</div>') +
        '<div class="pdp-stock ' + (inStock(p) ? 'in' : 'out') + '"' + (isOskQuote(p) ? ' style="margin-top:22px"' : '') + '>' + (inStock(p) ? 'In stock' : 'Sold Out') + '</div>' +
        (isOskQuote(p) ?
          '<a class="fv3-add fv3-quote-btn" href="/pages/contact" style="display:flex;align-items:center;justify-content:center;width:100%;box-sizing:border-box;text-decoration:none;font-weight:700;padding:10px 24px;height:auto;min-height:0;margin-top:6px;cursor:pointer">Call for Quote</a>' :
          inStock(p) ?
          '<div class="fv3-buyrow">' +
          '<div class="fv3-step"><button type="button" class="dec" aria-label="Decrease quantity">&minus;</button><b aria-live="polite">1</b><button type="button" class="inc" aria-label="Increase quantity">+</button></div>' +
          '<button class="fv3-add">Add to cart</button>' +
          '</div>' :
          // Sold out (non-quote): green "Email me when it's back" reveals a back-in-stock
          // email capture that notifies the store via Shopify's contact form (David 2026-07-28).
          '<div class="fv3-buyrow"><button type="button" class="fv3-add fv3-notify-btn" data-notify>Email me when it&rsquo;s back</button></div>' +
          '<div class="fv3-notify" data-sku="' + esc(p.sku) + '" hidden>' +
          '<div class="fv3-notify-row"><input type="email" class="fv3-notify-email" placeholder="you@nudibranchmail.com*" aria-label="Email me when this is back in stock" autocomplete="email" />' +
          '<button type="button" class="fv3-notify-send">Notify me</button></div>' +
          '<div class="fv3-notify-msg" role="status" aria-live="polite"></div>' +
          '</div>') +
        (BOGO_SKUS[(p.sku || "").toUpperCase()] ? '<div class="pdp-bogo" style="margin-top:12px;font-size:14px;font-weight:600;color:#0D7D68;">Buy One, Get One Free<span style="font-weight:400;color:#0D7D68"> - just add 2 to cart. No code needed.</span></div>' : '') +
        '<div class="pdp-net">Net-30 available for qualified labs.</div>' +
        specHtml;
      grid.appendChild(buy);
      pdp.appendChild(grid);
      // About this product — product.description prose (dropped in the V3
      // rebuild, restored per David 2026-07-25). Fetched from
      // /products/<handle>.js so client-side PDP navigation gets the right
      // copy too; tables/media inside the description duplicate the native
      // fv3-spec table and gallery, so only prose survives.
      var about = el("div", "fv3-about");
      about.style.display = "none";
      pdp.appendChild(about);
      if (p.handle) {
        fetch(CFG.productBase + p.handle + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          if (!d || !d.description) return;
          var scratch = document.createElement("div");
          scratch.innerHTML = d.description;
          ["table", "style", "script", "img", "iframe"].forEach(function (t) {
            Array.prototype.slice.call(scratch.querySelectorAll(t)).forEach(function (n) { n.parentNode.removeChild(n); });
          });
          Array.prototype.slice.call(scratch.querySelectorAll("*")).forEach(function (n) {
            Array.prototype.slice.call(n.attributes).forEach(function (a) {
              if (/^on/i.test(a.name) || (a.name === "href" && /^\s*javascript:/i.test(a.value))) n.removeAttribute(a.name);
            });
          });
          var prose = (scratch.textContent || "").replace(/\s+/g, " ").trim();
          if (prose.length < 40) return;
          about.appendChild(el("h3", null, "About this product"));
          var body = el("div", "fv3-about-body");
          body.innerHTML = scratch.innerHTML;
          about.appendChild(body);
          about.style.display = "";
        }).catch(function () {});
      }
      // pairs with (same-family neighbors first; then fill from the rest of the
      // catalog so EVERY product page shows a full "Pairs with" row - David
      // 2026-07-23 "should have the pairs with for everything")
      var neighbors = (maps.byFamily[p.primary_family] || []).filter(function (q) { return q.sku !== p.sku; });
      if (neighbors.length < 4) {
        var seenN = {}; seenN[p.sku] = 1;
        neighbors.forEach(function (nb) { seenN[nb.sku] = 1; });
        var pool = IDX.products || [];
        for (var pn = 0; pn < pool.length && neighbors.length < 4; pn++) {
          var cand = pool[pn];
          if (cand && cand.vid && !seenN[cand.sku]) { seenN[cand.sku] = 1; neighbors.push(cand); }
        }
      }
      neighbors = neighbors.slice(0, 4);
      if (neighbors.length) {
        var pr = el("div", "fv3-pairs");
        pr.appendChild(el("h3", null, "Pairs with"));
        var row = el("div", "fv3-pairs-row");
        neighbors.forEach(function (q) {
          var card = el("div", "fv3-pcard");
          var a = el("a", "pc-link");
          // real href, not a JS-only click, so middle-click/new-tab works
          // (QA R1 prose note)
          a.href = pdpHref(q);
          a.innerHTML = '<div class="pc-img">' + (q.image ? '<img src="' + esc(q.image) + '" alt="" loading="lazy" />' : '<span class="ph">' + esc(fam.display || "Filtrous") + '</span>') + '</div>' +
            '<div class="pc-body"><div class="pc-t">' + esc(q.title.split(",")[0]) + '</div><div class="pc-sku">SKU: <b>' + esc(q.sku) + '</b></div>' + (isOskQuote(q) ? '' : '<div class="pc-p">' + priceOrQuote(q) + '</div>') + '</div>';
          card.appendChild(a);
          // qty stepper + Add to cart on each card (David 2026-07-23). The
          // buttons live OUTSIDE the link and stop propagation so a click adds
          // to cart instead of navigating to the neighbor's PDP.
          var avail = inStock(q);
          var act = el("div", "pc-actions");
          // Sold-out cards drop the qty stepper entirely; only the "Sold Out" button remains (David 2026-07-28).
          act.innerHTML = isOskQuote(q) ?
            '<a class="pc-add" href="/pages/contact" style="display:flex;align-items:center;justify-content:center;text-decoration:none">Call for Quote</a>' :
            ((avail ? '<div class="pc-step"><button type="button" class="dec" aria-label="Decrease quantity">&minus;</button><b aria-live="polite">1</b><button type="button" class="inc" aria-label="Increase quantity">+</button></div>' : '') +
            '<button type="button" class="pc-add"' + (avail ? '' : ' disabled') + '>' + (avail ? 'Add to cart' : 'Sold Out') + '</button>');
          card.appendChild(act);
          (function (prod, cardEl) {
            var n = 1, b = $(".pc-step b", cardEl);
            var dec = $(".pc-step .dec", cardEl), inc = $(".pc-step .inc", cardEl), ab = $(".pc-add", cardEl);
            if (dec) dec.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); n = Math.max(1, n - 1); b.textContent = n; });
            if (inc) inc.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); n = n + 1; b.textContent = n; });
            if (ab && inStock(prod) && !isOskQuote(prod)) ab.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); addToCart(prod, n, ab); });
          })(q, card);
          row.appendChild(card);
        });
        pr.appendChild(row); pdp.appendChild(pr);
      }
      shell.appendChild(pdp);
      // stepper + add wiring
      var qty = 1, qEl = $(".fv3-step b", pdp);
      var step = $(".fv3-step", pdp);
      if (step && !step.getAttribute("data-off")) {
        step.querySelector(".dec").addEventListener("click", function () { qty = Math.max(1, qty - 1); qEl.textContent = qty; });
        step.querySelector(".inc").addEventListener("click", function () { qty = qty + 1; qEl.textContent = qty; });
      }
      var addBtn = $(".fv3-buyrow .fv3-add", pdp);
      if (inStock(p) && addBtn) addBtn.addEventListener("click", function () { addToCart(p, qty, addBtn); });
      wireNotify(pdp, p);
      if (isOskQuote(p)) {
        var sizeQuoteBtn = function () {
          var qbtn = $(".fv3-quote-btn", pdp), titleEl = $(".fv3-buy h1", pdp);
          if (!qbtn || !titleEl) return;
          var rng = document.createRange(); rng.selectNodeContents(titleEl);
          var rects = rng.getClientRects(), w = 0;
          for (var i = 0; i < rects.length; i++) w = Math.max(w, rects[i].width);
          w = Math.ceil(w);
          if (w > 0) qbtn.style.width = w + "px";
        };
        sizeQuoteBtn();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeQuoteBtn);
      }
    });
  }

  /* ---------------- router ---------------- */
  function route() {
    var h = location.hash || "#/";
    // big navy face band on home only; compact sticky header elsewhere
    if (MOUNT) MOUNT.classList.toggle("fv3-home", h === "#/" || h === "#" || h === "" || /^#\/c\//.test(h));
    var m;
    if ((m = h.match(/^#\/f\/([^?]+)(?:\?(.*))?$/))) {
      var pf = null, qs = m[2];
      if (qs) {
        var kv = {}; qs.split("&").forEach(function (p) { var a = p.split("="); kv[a[0]] = decodeURIComponent(a[1] || ""); });
        if (kv.k) pf = { key: kv.k, val: kv.v };
      }
      return viewSheet(decodeURIComponent(m[1]), pf);
    }
    if ((m = h.match(/^#\/p\/(.+)$/))) return viewPDP(m[1]);
    if (h === "#/quality") return viewQuality();
    if ((m = h.match(/^#\/s\/(.+)$/))) return viewSearchResults(decodeURIComponent(m[1]));
    if ((m = h.match(/^#\/d\/([^/]+)\/(.+)$/))) return viewDept(m[1], decodeURIComponent(m[2]));
    if ((m = h.match(/^#\/d\/([^/]+)$/))) return viewDept(m[1], null);
    return viewHome(); // home = full directory of all departments
  }

  /* ---------------- init ---------------- */
  function init(mountSel) {
    MOUNT = typeof mountSel === "string" ? $(mountSel) : mountSel;
    if (!MOUNT) return;
    MOUNT.classList.add("fv3");
    MOUNT.appendChild(chrome());
    var shell = el("div", "fv3-shell"); shell.appendChild(el("div", "fv3-load", "Loading catalog…"));
    MOUNT.appendChild(shell);
    MOUNT.appendChild(footer());
    $(".fv3-cart", MOUNT).addEventListener("click", openCart);
    fetch(CFG.indexUrl, { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        IDX = data; build(); refreshCart();
        window.addEventListener("hashchange", route);
        // support server-rendered PDP bootstrap
        if (CFG.pdpSku) { viewPDP(CFG.pdpSku); }
        else if (CFG.sheetHandle && !location.hash) { location.hash = "#/f/" + CFG.sheetHandle; route(); }
        else route();
      })
      .catch(function (e) {
        $(".fv3-shell", MOUNT).innerHTML = '<div class="fv3-load">Could not load the catalog index. ' + esc(String(e)) + '</div>';
      });
  }
  window.FiltrousV3 = { init: init };
  if (CFG.autoMount) init(CFG.autoMount);
})();
